<app-card-layout [info]="info"></app-card-layout>